module.exports = __webpack_public_path__ + "static/media/32_tn.50d2e0f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/32_tn.jpg
// module id = 520
// module chunks = 0